import React from 'react';
import { Link } from 'react-router-dom';
import Nav from './Nav';
import Footer from './Footer';

// Public, no-login-required page describing how to delete a Your Top 8 account and
// what data is removed. Google Play requires a web-reachable account-deletion
// method for apps that let users create an account.
function DeleteAccount({ currentUser, currentUserProfile }) {
  return (
    <>
      <Nav currentUser={currentUser} currentUserProfile={currentUserProfile} />
      <div style={{ maxWidth: 680, margin: '0 auto', padding: '48px 20px 80px' }}>
        <Link to="/" style={{ fontSize: 13, color: 'var(--muted)', textDecoration: 'none', display: 'inline-block', marginBottom: 32 }}>
          ← Back
        </Link>
        <h1 style={{ fontSize: 26, fontWeight: 800, letterSpacing: '-.3px', marginBottom: 6 }}>Delete your account</h1>
        <p style={{ color: 'var(--muted)', fontSize: 13, marginBottom: 40 }}>
          Your Top 8™
        </p>

        <div style={{ color: 'var(--text)', lineHeight: 1.75, fontSize: 15 }}>
          <p style={{ margin: '0 0 16px', color: 'var(--muted)' }}>
            You can permanently delete your Your Top 8 account and its data at any time. There are two ways to do it.
          </p>

          <h2 style={{ fontSize: 17, fontWeight: 700, margin: '32px 0 10px' }}>In the app or on the web</h2>
          <ol style={{ margin: '0 0 16px', paddingLeft: 20, color: 'var(--muted)' }}>
            <li style={{ marginBottom: 8 }}>Sign in to Your Top 8.</li>
            <li style={{ marginBottom: 8 }}>Go to <strong>Settings</strong>.</li>
            <li style={{ marginBottom: 8 }}>Scroll to <strong>Danger Zone</strong> and choose <strong>Delete account</strong>.</li>
            <li style={{ marginBottom: 8 }}>Confirm. The deletion is immediate and cannot be undone.</li>
          </ol>
          {currentUser && (
            <p style={{ margin: '0 0 16px' }}>
              <Link to="/settings" className="btn btn-primary btn-sm">Go to Settings</Link>
            </p>
          )}

          <h2 style={{ fontSize: 17, fontWeight: 700, margin: '32px 0 10px' }}>By email</h2>
          <p style={{ margin: '0 0 16px', color: 'var(--muted)' }}>
            If you can't access your account, email{' '}
            <a href="mailto:support@yourtop8.com">support@yourtop8.com</a> from the address tied to your
            account and ask us to delete it. We'll verify ownership and remove it.
          </p>

          <h2 style={{ fontSize: 17, fontWeight: 700, margin: '32px 0 10px' }}>Delete specific data without deleting your account</h2>
          <p style={{ margin: '0 0 16px', color: 'var(--muted)' }}>
            You don't have to delete your whole account to remove individual data. While signed in, you can:
          </p>
          <ul style={{ margin: '0 0 16px', paddingLeft: 20, color: 'var(--muted)' }}>
            <li style={{ marginBottom: 8 }}>Remove or change your profile photo and clear your bio in <strong>Settings</strong>.</li>
            <li style={{ marginBottom: 8 }}>Delete your phone number and any social links in <strong>Settings</strong>.</li>
            <li style={{ marginBottom: 8 }}>Remove people from your Top 8, your connections, and your prospects in the editor.</li>
          </ul>
          <p style={{ margin: '0 0 16px', color: 'var(--muted)' }}>
            These changes take effect immediately. If you'd like us to remove specific data for you, email{' '}
            <a href="mailto:support@yourtop8.com">support@yourtop8.com</a> from your account's address.
          </p>

          <h2 style={{ fontSize: 17, fontWeight: 700, margin: '32px 0 10px' }}>What gets deleted</h2>
          <ul style={{ margin: '0 0 16px', paddingLeft: 20, color: 'var(--muted)' }}>
            <li style={{ marginBottom: 8 }}>Your profile (display name, username, bio, photo) and your Top 8.</li>
            <li style={{ marginBottom: 8 }}>Your email address and any saved phone number.</li>
            <li style={{ marginBottom: 8 }}>Your connections, prospects, social links, and notifications.</li>
            <li style={{ marginBottom: 8 }}>Your sign-in credentials. Your username is released for others to use.</li>
          </ul>
          <p style={{ margin: '0 0 16px', color: 'var(--muted)' }}>
            Where your account appeared in other people's Top 8 lists, your tile is demoted to a basic
            entry so their list isn't broken. Deletion is permanent and takes effect immediately. We may
            retain limited records where required by law.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default DeleteAccount;
